import React from 'react';

const Home = () => (
  <div>
    <h2 className="homeTitle">Welcome to our page!</h2>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi,
      assumenda. Accusamus quo officiis error quam soluta perspiciatis dolor ab
      repudiandae consectetur quaerat. Quae magnam delectus fugit repudiandae
      suscipit, est obcaecati. Lorem ipsum dolor, sit amet consectetur
      adipisicing elit. Nesciunt ipsa necessitatibus quos, sed harum, nostrum
      repellendus eveniet consectetur, illum doloribus nisi. Rerum ullam ea ipsa
      odio ad facere, placeat quos? Lorem ipsum dolor sit, amet consectetur
      adipisicing elit. Cupiditate, tempora. Ab corrupti consequatur assumenda,
      quasi sint minus ex totam obcaecati? Sit at harum suscipit dolore
      laudantium deserunt ex eum facere!
      <br />
      <br />
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi,
      assumenda. Accusamus quo officiis error quam soluta perspiciatis dolor ab
      repudiandae consectetur quaerat. Quae magnam delectus fugit repudiandae
      suscipit, est obcaecati. Lorem ipsum dolor, sit amet consectetur
      adipisicing elit. Nesciunt ipsa necessitatibus quos, sed harum, nostrum
      repellendus eveniet consectetur, illum doloribus nisi. Rerum ullam ea ipsa
      odio ad facere, placeat quos? Lorem ipsum dolor sit, amet consectetur
      adipisicing elit. Cupiditate, tempora. Ab corrupti consequatur assumenda,
      quasi sint minus ex totam obcaecati? Sit at harum suscipit dolore
      laudantium deserunt ex eum facere!
    </p>
  </div>
);

export default Home;
